import { apiClient } from './client';
import { buildApiUrl } from './config';
import type {
  PumpAssignmentListResponse,
  PumpAssignment,
  PumpAssignmentCreateRequest,
  PumpAssignmentUpdateRequest,
} from '@/types/pumpAssignment';

export const pumpAssignmentsApi = {
  async list(deviceId: string): Promise<PumpAssignmentListResponse> {
    const url = buildApiUrl(`/api/devices/${deviceId}/pump-assignments`);
    const response = await apiClient(url, { method: 'GET' });
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(error.detail || `HTTP ${response.status}`);
    }
    return response.json();
  },

  async create(deviceId: string, data: PumpAssignmentCreateRequest): Promise<PumpAssignment> {
    const url = buildApiUrl(`/api/devices/${deviceId}/pump-assignments`);
    const response = await apiClient(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(error.detail || `HTTP ${response.status}`);
    }
    return response.json();
  },

  async update(
    deviceId: string,
    assignmentId: number,
    data: PumpAssignmentUpdateRequest
  ): Promise<PumpAssignment> {
    const url = buildApiUrl(`/api/devices/${deviceId}/pump-assignments/${assignmentId}`);
    const response = await apiClient(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(error.detail || `HTTP ${response.status}`);
    }
    return response.json();
  },

  async delete(deviceId: string, assignmentId: number): Promise<void> {
    const url = buildApiUrl(`/api/devices/${deviceId}/pump-assignments/${assignmentId}`);
    const response = await apiClient(url, { method: 'DELETE' });
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(error.detail || `HTTP ${response.status}`);
    }
  },
};
